import React from 'react'
import { geolocated } from 'react-geolocated'

const Demo = ({ isGeolocationAvailable, isGeolocationEnabled, coords }) => {
  return !isGeolocationAvailable
    ? <div>Your browser does not support Geolocation</div>
    : !isGeolocationEnabled
        ? <div>Geolocation is not enabled</div>
        : coords
          ? <a href={`http://www.google.com/maps/place/${coords.latitude},${coords.longitude}/@${coords.latitude},${coords.longitude},17z/data=!3m1!1e3`} target='_blank' rel='noreferrer'>
            <table>
              <tbody>
                <tr><td>latitude</td><td>{coords.latitude}</td></tr>
                <tr><td>longitude</td><td>{coords.longitude}</td></tr>
                <tr><td>altitude</td><td>{coords.altitude}</td></tr>
                <tr><td>heading</td><td>{coords.heading}</td></tr>
                <tr><td>speed</td><td>{coords.speed}</td></tr>
              </tbody>
            </table>
            </a>
          : <div>Getting the location data&hellip; </div>
}

export default geolocated({
  positionOptions: {
    enableHighAccuracy: true,
  },
  userDecisionTimeout: 5000,
})(Demo)
